export const GET_LOCATIONS = "GET_LOCATIONS";
export const GET_LOCATIONS_SUCCESS = "GET_LOCATIONS_SUCCESS";
export const GET_LOCATIONS_FAIL = "GET_LOCATIONS_FAIL";

export const ADD_LOCATIONS_SUCCESS = "ADD_LOCATIONS_SUCCESS";
export const ADD_LOCATIONS_FAIL = "ADD_LOCATIONS_FAIL";
export const UPDATE_LOCATIONS_SUCCESS = "UPDATE_LOCATIONS_SUCCESS";
export const DELETE_LOCATIONS_SUCCESS = "DELETE_LOCATIONS_SUCCESS";
